import { render, staticRenderFns } from "./viewUpdateDetailEmployee.vue?vue&type=template&id=2652b6c0&scoped=true&"
import script from "./viewUpdateDetailEmployee.vue?vue&type=script&lang=js&"
export * from "./viewUpdateDetailEmployee.vue?vue&type=script&lang=js&"
import style0 from "./viewUpdateDetailEmployee.vue?vue&type=style&index=0&id=2652b6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652b6c0",
  null
  
)

export default component.exports